import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { types as ChannelTypes } from 'remote/channels/types'
import { goToOrganizationUpgrade } from 'data/ui/actions'
import { Toggle } from 'components/base'

class ChannelTypeSelector extends Component {
  static propTypes = {
    value: PropTypes.oneOf([ChannelTypes.PUBLIC, ChannelTypes.PRIVATE]),
    onChange: PropTypes.func.isRequired,
  }

  render() {
    const { value, className, onChange, disabled } = this.props
    return (
      <Toggle
        disabled={disabled}
        checked={value === ChannelTypes.PRIVATE}
        onChange={() =>
          onChange(
            value === ChannelTypes.PUBLIC
              ? ChannelTypes.PRIVATE
              : ChannelTypes.PUBLIC
          )
        }
        className={className}
      />
    )
  }
}
ChannelTypeSelector.defaultProps = {
  disabled: false,
}

export default connect(
  null,
  { goToOrganizationUpgrade }
)(ChannelTypeSelector)
